import type {
  CustomEdge,
  CustomNode,
} from '@src/components/custom-nodes/types/custom-nodes.type';

interface ReconnectNodesByParentIdProps {
  edges: CustomEdge[];
  nodes: CustomNode[];
  deleteNodeId: string;
}
export const reconnectNodesByParentId = ({ edges, nodes, deleteNodeId }: ReconnectNodesByParentIdProps) => {
  // find the edge which contains nodeToRemove as target
  const edgeToRemoveTarget = edges.find((edge) => edge.target === deleteNodeId);
  // find the edge which contains nodeToRemove as source
  const edgeToRemoveSource = edges.find((edge) => edge.source === deleteNodeId);
  // update target nodefrom edgeToRemoveSource to have parentNodeId taken from edgeToRemove source
  if (edgeToRemoveSource) {
    const sourceNode = nodes.find((n) => n.id === edgeToRemoveTarget?.source);
    if (sourceNode) {
      const targetNode = nodes.find((n) => n.id === edgeToRemoveSource?.target);
      if (targetNode) {
        targetNode.parentNodeId = sourceNode.id;
      }
    }
  }
}
